
import { defineComponent, PropType } from 'vue'
import type { FetchResult } from 'apollo-link'
import CreateBillingPortalSessionMutation from '~/apollo/mutations/owner/createBillingPortalSession.gql'
import type { BillingAddress } from '~/types/types'

export default defineComponent({
  name: 'V2BillingInfo',
  props: {
    billingEmail: {
      type: String,
      default: ''
    },
    billingAddress: {
      type: Object as PropType<BillingAddress | null>,
      default: null
    },
    loading: {
      type: Boolean,
      default: true
    },
    ownerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    formattedAddress(): string {
      const a = this.billingAddress
      if (!a) return ''
      return [a.line1, a.line2, a.city, a.state, a.postalCode, a.country].filter(Boolean).join(', ')
    }
  },
  methods: {
    async openBillingPortal() {
      this.isLoading = true
      try {
        const result = (await this.$applyGraphqlMutation(CreateBillingPortalSessionMutation, {
          ownerId: this.ownerId
        })) as FetchResult<{ createBillingPortalSession: { url: string } }>
        const url = result.data?.createBillingPortalSession?.url
        if (url) {
          const newTab = window.open(url, '_blank')
          if (newTab) {
            newTab.opener = null
          } else {
            this.$toast.info(
              'Popup blocked by your browser. Please allow popups for this site and try again.'
            )
          }
        }
      } catch (error) {
        this.$logErrorAndToast(
          error as Error,
          'We encountered an error while opening the billing portal. Please try again later.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
